/**
 * assets/mom-mini-cart.js  — v2  (IMPULSE THEME)
 *
 * Change from v1:
 *   v1 → added TWO items (mom variant + mini variant) → cart showed two lines at individual prices
 *   v2 → finds the matching variant on the Set Product → adds ONE item at the set price ($140)
 *
 * Requirement: window.kashkiyaSetVariants must be set by the Liquid template.
 * The Set Product must have:
 *   Option 1: Mum's Size  (values matching the Women's product variant titles: "6","8","10"…)
 *   Option 2: Mini's Size (values matching the Kids product variant titles: "1","2","4","6","8","10")
 */

(function () {
  'use strict';

  const state = {
    momLabel:  null,   // e.g. "12"
    miniLabel: null,   // e.g. "4"
  };

  const addToCartBtn     = document.getElementById('mom-mini-add-to-cart');
  const mumDisplay       = document.getElementById('mum-selected-display');
  const miniDisplay      = document.getElementById('mini-selected-display');
  const summaryBox       = document.getElementById('selection-summary');
  const summaryMomSize   = document.getElementById('summary-mom-size');
  const summaryMiniSize  = document.getElementById('summary-mini-size');
  const errorMsg         = document.getElementById('cart-error-message');
  const unavailableMsg   = document.getElementById('size-unavailable-msg');

  if (!addToCartBtn) return;

  // ── Size button clicks ──────────────────────────────────────────
  document.querySelectorAll('.sz-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const type = this.dataset.type;

      document.querySelectorAll('.sz-btn[data-type="' + type + '"]').forEach(function (b) {
        b.classList.remove('selected');
      });
      this.classList.add('selected');

      if (type === 'mom') {
        state.momLabel = this.dataset.size;
        if (mumDisplay) mumDisplay.textContent = '— ' + state.momLabel;
      } else {
        state.miniLabel = this.dataset.size;
        if (miniDisplay) miniDisplay.textContent = '— ' + state.miniLabel;
      }

      updateUI();
    });
  });

  // ── Find matching Set Product variant ──────────────────────────
  // The Set Product has Option1 = Mum's Size, Option2 = Mini's Size.
  // We match on the size label strings (e.g. "12" and "4").
  function findSetVariant(mumSize, miniSize) {
    var variants = window.kashkiyaSetVariants;
    if (!variants || !variants.length) return null;

    return variants.find(function (v) {
      return (
        v.option1 === mumSize &&
        v.option2 === miniSize &&
        v.available !== false
      );
    }) || null;
  }

  // ── Update button state ────────────────────────────────────────
  function updateUI() {
    if (unavailableMsg) unavailableMsg.hidden = true;
    if (errorMsg)       errorMsg.hidden       = true;

    if (state.momLabel && state.miniLabel) {
      // Check if this combination exists on the set product
      var variant = findSetVariant(state.momLabel, state.miniLabel);

      if (summaryBox) {
        summaryBox.hidden = false;
        if (summaryMomSize)  summaryMomSize.textContent  = 'Size ' + state.momLabel;
        if (summaryMiniSize) summaryMiniSize.textContent = 'Size ' + state.miniLabel;
      }

      if (variant) {
        addToCartBtn.disabled    = false;
        addToCartBtn.textContent =
          'Add Mum (' + state.momLabel + ') + Mini (' + state.miniLabel + ') to Cart';
        if (unavailableMsg) unavailableMsg.hidden = true;
      } else {
        // Combination doesn't exist in the set product yet
        addToCartBtn.disabled    = true;
        addToCartBtn.textContent = 'Size Combination Unavailable';
        if (unavailableMsg) unavailableMsg.hidden = false;
      }
    } else {
      if (summaryBox) summaryBox.hidden = true;
      addToCartBtn.disabled    = true;
      addToCartBtn.textContent = 'Select Both Sizes to Continue';
    }
  }

  // ── Add ONE Set Product variant to cart ────────────────────────
  addToCartBtn.addEventListener('click', async function () {
    if (!state.momLabel || !state.miniLabel) return;

    var variant = findSetVariant(state.momLabel, state.miniLabel);
    if (!variant) return;

    var orig = addToCartBtn.textContent;
    addToCartBtn.disabled    = true;
    addToCartBtn.textContent = 'Adding...';
    if (errorMsg) errorMsg.hidden = true;

    try {
      // Add ONE item — the Set Product variant at the bundle price ($140)
      // This is what makes the cart show a single line item, just like Fashiana
      var res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: {
          'Content-Type':     'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [
            {
              id:       variant.id,
              quantity: 1,
              // Optional: add line item properties so cart shows the sizes clearly
              properties: {
                'Mum\'s Size':  state.momLabel,
                'Mini\'s Size': state.miniLabel,
              }
            }
          ]
        }),
      });

      var data = await res.json();

      if (res.ok) {
        // ── IMPULSE THEME: open cart drawer ──────────────────────
        var cartRes  = await fetch('/cart.js');
        var cartData = await cartRes.json();

        document.dispatchEvent(new CustomEvent('cart:build', {
          detail: { cart: cartData }
        }));

        var flyout = document.querySelector('[data-js="cart-flyout"]');
        if (flyout) {
          flyout.classList.add('is-active');
          document.body.classList.add('cart-flyout-open');
        } else {
          var toggle = document.querySelector('[data-js="cart-button"], .js-cart-count');
          if (toggle) toggle.click();
        }

        // Update cart count badge in header
        document.querySelectorAll(
          '.cart-count, [data-cart-count], .js-cart-count'
        ).forEach(function (el) {
          el.textContent = cartData.item_count;
        });

        // Success state
        addToCartBtn.textContent      = '✓ Added to Cart!';
        addToCartBtn.style.background = '#2d9e5f';

        setTimeout(function () {
          addToCartBtn.disabled         = false;
          addToCartBtn.textContent      = orig;
          addToCartBtn.style.background = '';
        }, 2500);

      } else {
        showError(data.description || 'Could not add to cart. Please try again.');
        addToCartBtn.disabled    = false;
        addToCartBtn.textContent = orig;
      }

    } catch (e) {
      showError('Something went wrong. Please refresh and try again.');
      addToCartBtn.disabled    = false;
      addToCartBtn.textContent = orig;
    }
  });

  function showError(msg) {
    if (!errorMsg) return;
    errorMsg.textContent = msg;
    errorMsg.hidden      = false;
  }

  // ── Thumbnail gallery ──────────────────────────────────────────
  document.querySelectorAll('.mms-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var img = document.getElementById('mms-main-img');
      if (img && this.dataset.src) {
        img.style.opacity = '0';
        var src = this.dataset.src;
        setTimeout(function () {
          img.src           = src;
          img.style.opacity = '1';
        }, 150);
      }
      document.querySelectorAll('.mms-thumb').forEach(function (t) {
        t.classList.remove('mms-thumb--active');
      });
      this.classList.add('mms-thumb--active');
    });
  });

})();
